/**
 * FIREBASE CONFIGURATION
 * 
 * This file sets up the connection to Firebase.
 * Firebase is a "Backend as a Service" - it gives us:
 * - Authentication (user login/signup)
 * - Firestore Database (stores our polish data)
 * - Storage (stores photos)
 * - Hosting (optional - we're using Digital Ocean instead)
 * 
 * IMPORTANT: You'll need to replace the firebaseConfig object below
 * with your own Firebase project credentials.
 */

import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

/**
 * Firebase Project Configuration
 * 
 * TO SET THIS UP:
 * 1. Go to https://console.firebase.google.com/
 * 2. Create a new project (or use existing)
 * 3. Click "Add app" and choose "Web"
 * 4. Copy the firebaseConfig object they show you
 * 5. Replace the placeholder below with your config
 * 
 * SECURITY NOTE: These values are safe to commit to GitHub.
 * The real security comes from Firebase Security Rules, which
 * we'll set up later.
 */
const firebaseConfig = {
  apiKey: "AIzaSyCXg3NDkdpI9sUkMIKiaNP7mVF5-99NjYo",
  authDomain: "polish-all-the-things--app.firebaseapp.com",
  projectId: "polish-all-the-things--app",
  storageBucket: "polish-all-the-things--app.firebasestorage.app",
  messagingSenderId: "795888439824",
  appId: "1:795888439824:web:94e07ddc5a8592c768f095"
};

/**
 * Initialize Firebase
 * This creates the connection to your Firebase project
 */
const app = initializeApp(firebaseConfig);

/**
 * Initialize Firebase Services
 * 
 * - auth: Handles user authentication (login, signup, logout)
 * - db: The Firestore database (where we store polish data)
 * - storage: File storage (where we store photos)
 */
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, 'us-central1');

/**
 * Export the app instance in case we need it elsewhere
 */
export { app };
export default app;
